// React imports
import { useContext } from "react";
// State
import { useDraftOrderStaff } from "../../state/draftOrderStaffState";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { OrderItems } from "../../components/OrderItems";

// MUI
import Box from "@mui/material/Box";
// import Typography from "@mui/material/Typography";
// import Stack from "@mui/material/Stack";

export const ItemSelection = ({ order, items, setItems }) => {
  // Order data
  const person = order?.data?.staff[0];
  const orderNo = order?.data?.order?.no;
  // Fetch Draft Order Lines
  // const [items, setItems] = useState({ selected: [], core: [], accessory: [] });
  // const [reasons, setReasons] = useState([]);
  const { setAlertNotification } = useContext(AlertNotificationContext);

  // Get Order Staff Lines
  const { isPending, data, isSuccess } = useDraftOrderStaff(
    orderNo,
    person.staffLineNo,
    orderNo ? true : false,
  );

  // Success Function
  const successFunc = () => {
    const items = data.data.data.data.data.lines;
    if (!items) return;
    const reasons = data.data.data.data.data.reasons;
    const coreItems = items.filter((item) => item.type === "Core");
    const accessoryItems = items.filter((item) => item.type === "Accessory");
    const selectedItems = items.filter((item) => item.itemNo);
    setItems({
      selected: selectedItems,
      core: coreItems,
      accessory: accessoryItems,
    });
    // setReasons(reasons);
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      {/* {reasons.length > 0 && (
        <Box sx={{ m: 1, mb: 2 }}>
          <Typography variant="h6" sx={{ pb: 2 }}>
            Reason for request
          </Typography>
          <OrderReasonSelect
            reasons={reasons}
            reasonCode={person.reasonCode}
            order={order?.data?.order.no}
            person={person.staffLineNo}
            fullWidth
          />
        </Box>
      )} */}
      <OrderItems
        person={person}
        order={order?.data?.order}
        items={items}
        loading={isPending}
        staffRequest
        itemsCount={person.numberOfLines}
        orderType="staffRequest"
        // entitlementWarn
        // entitlementLock
      />
    </Box>
  );
};
